import React, { useEffect, useState, useCallback } from "react";
import styles from "./FastProductsModal.module.css";
import { X } from "lucide-react";
import { API_URL } from "../../../config/api";

const API_BASE = `${API_URL}/api/stocks`;

export default function FastProductsModal({
  open,
  onClose,
  onAddProduct,
  warehouseId,
}) {
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  const pageSize = 12;

  // ✅ useCallback чтобы ESLint не ругался
  const fetchProducts = useCallback(async () => {
    if (!token) {
      console.error("❌ Нет токена! Авторизация не выполнена.");
      return;
    }

    try {
      setLoading(true);
      const resp = await fetch(
        `${API_BASE}?is_fast=true&storage_id=${warehouseId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!resp.ok)
        throw new Error(`Failed to fetch fast products: ${resp.status}`);

      const data = await resp.json();

      if (Array.isArray(data.data)) {
        setProducts(data.data);
        localStorage.setItem("fastProducts", JSON.stringify(data.data));
      } else {
        setProducts([]);
      }
    } catch (err) {
      console.error("Ошибка загрузки быстрых товаров:", err);
      const saved = localStorage.getItem("fastProducts");
      if (saved) setProducts(JSON.parse(saved));
    } finally {
      setLoading(false);
    }
  }, [token, warehouseId]);

  // ✅ Один правильный useEffect
  useEffect(() => {
    if (!open) return;
    fetchProducts();
  }, [open, fetchProducts]);

  const handleProductClick = (product) => {
    const row = {
      id: product.product_id,
      article: product.article,
      name: product.name_ru || product.name || "—",
      price: parseFloat(product.price || 0),
      qty: 1,
      quantity: product.quantity,
    };
    onAddProduct(row);
  };

  if (!open) return null;

  const totalPages = Math.ceil(products.length / pageSize);
  const paginatedProducts = products.slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.title}>Быстрые товары</div>
          <button
            className={styles.closeBtn}
            onClick={onClose}
            aria-label="Закрыть"
          >
            <X size={20} />
          </button>
        </div>

        <div className={styles.content}>
          {loading ? (
            <div className={styles.loading}>Загрузка...</div>
          ) : (
            <>
              <div className={styles.grid}>
                {paginatedProducts.length > 0 ? (
                  paginatedProducts.map((p) => (
                    <button
                      key={p.id}
                      className={styles.card}
                      onClick={() => handleProductClick(p)}
                      title={`${p.name_ru || p.name}\nЦена: ${p.sell_price}`}
                    >
                      <div className={styles.cardName}>
                        {p.name_ru || p.name}
                      </div>
                    </button>
                  ))
                ) : (
                  <div className={styles.noProducts}>
                    Нет быстрых товаров
                  </div>
                )}
              </div>

              {totalPages > 1 && (
                <div className={styles.pager}>
                  <button
                    onClick={() => setPage((s) => Math.max(1, s - 1))}
                    disabled={page <= 1}
                  >
                    Назад
                  </button>

                  <div className={styles.pageInfo}>
                    Страница {page} из {totalPages}
                  </div>

                  <button
                    onClick={() =>
                      setPage((s) => Math.min(totalPages, s + 1))
                    }
                    disabled={page >= totalPages}
                  >
                    Вперед
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
